const TAX = 0.22 // 22% tax

/**
* @desc Styled components mixin for fluid typography - https://www.youtube.com/watch?v=Wb5xDcUNq48
* @param string minScreen - min screen width
* @param string maxScreen - max screen width
* @param string minFont - min font size
* @param string maxFont - max font size
* @return string - Template literal containing CSS
*/

export function fluidType (minScreen, maxScreen, minFont, maxFont) {
  return `
  font-size: calc(${minFont} + (${parseInt(maxFont) - parseInt(minFont)}) * (100vw - ${minScreen})/(${parseInt(maxScreen) - parseInt(minScreen)}));
  `
}

/**
* @desc Format number price using locale
* @param float price - Input price
* @return string - Price formatted
*/

export function priceFormatted (price) {
  console.log(price)
  return price && price.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 })
}

/**
* @desc Get the net price from gross (Minus 22% tax)
* @param float price - Input gross price
* @return float netPrice - Net price
*/

export function getNetPrice (price) {
  // return 200
  return price - price * TAX
}

/**
* @desc Get the tax price from gross (22% of gross)
* @param float price - Input gross price
* @return float taxPrice - tax price
*/

export function getTax (price) {
  // return 200
  return price * TAX
}

// ROOT_URL - Base API URL
const baseURL = window.location.origin
export const ROOT_URL = process.env.NODE_ENV === 'production' ? `${baseURL}/api/v1` : 'http://localhost:5000/api/v1'

const siteURL = 'https://noleggiocampi.it'
// Menu items
export const menuItems = [
  {
    name: 'HOME',
    url: siteURL
  },
  {
    name: 'CONFIGURATORE',
    url: `/noleggia`
  },
  {
    name: 'VENDITA E NOLEGGIO',
    url: `${siteURL}/strutture`
  },
  {
    name: 'CHI SIAMO',
    url: `${siteURL}/chi-siamo`
  },
  {
    name: 'CONTATTACI',
    url: `${siteURL}/contattaci`
  }
]

// Chrome Devtools Screen Sizes
const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '480px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1200px',
  laptopL: '1440px',
  desktop: '1920px',
  desktopL: '2560px'
}

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobileMinS: `(min-width: ${size.mobileS})`,
  mobileMinM: `(min-width: ${size.mobileM})`,
  mobileMinL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktopL})`
}

// Dove items
export const doveItems = [
  {
    'name': 'Agrigento',
    'status': 'no'
  },
  {
    'name': 'Alessandria',
    'status': 'yes'
  },
  {
    'name': 'Ancona',
    'status': 'yes'
  },
  {
    'name': 'Aosta',
    'status': 'yes'
  },
  {
    'name': 'Arezzo',
    'status': 'yes'
  },
  {
    'name': 'Ascoli Piceno',
    'status': 'yes'
  },
  {
    'name': 'Asti',
    'status': 'yes'
  },
  {
    'name': 'Avellino',
    'status': 'yes'
  },
  {
    'name': 'Bari',
    'status': 'yes'
  },
  {
    'name': 'Barletta-Andria-Trani',
    'status': 'yes'
  },
  {
    'name': 'Belluno',
    'status': 'yes'
  },
  {
    'name': 'Benevento',
    'status': 'yes'
  },
  {
    'name': 'Bergamo',
    'status': 'yes'
  },
  {
    'name': 'Biella',
    'status': 'yes'
  },
  {
    'name': 'Bologna',
    'status': 'yes'
  },
  {
    'name': 'Bolzano',
    'status': 'yes'
  },
  {
    'name': 'Brescia',
    'status': 'yes'
  },
  {
    'name': 'Brindisi',
    'status': 'yes'
  },
  {
    'name': 'Cagliari',
    'status': 'no'
  },
  {
    'name': 'Caltanissetta',
    'status': 'no'
  },
  {
    'name': 'Campobasso',
    'status': 'yes'
  },
  {
    'name': 'Caserta',
    'status': 'yes'
  },
  {
    'name': 'Catania',
    'status': 'no'
  },
  {
    'name': 'Catanzaro',
    'status': 'no'
  },
  {
    'name': 'Chieti',
    'status': 'yes'
  },
  {
    'name': 'Como',
    'status': 'yes'
  },
  {
    'name': 'Cosenza',
    'status': 'no'
  },
  {
    'name': 'Cremona',
    'status': 'yes'
  },
  {
    'name': 'Crotone',
    'status': 'no'
  },
  {
    'name': 'Cuneo',
    'status': 'yes'
  },
  {
    'name': 'Enna',
    'status': 'no'
  },
  {
    'name': 'Fermo',
    'status': 'yes'
  },
  {
    'name': 'Ferrara',
    'status': 'yes'
  },
  {
    'name': 'Firenze',
    'status': 'yes'
  },
  {
    'name': 'Foggia',
    'status': 'yes'
  },
  {
    'name': 'Forl\u00ec-Cesena',
    'status': 'yes'
  },
  {
    'name': 'Frosinone',
    'status': 'yes'
  },
  {
    'name': 'Genova',
    'status': 'yes'
  },
  {
    'name': 'Gorizia',
    'status': 'yes'
  },
  {
    'name': 'Grosseto',
    'status': 'yes'
  },
  {
    'name': 'Imperia',
    'status': 'yes'
  },
  {
    'name': 'Isernia',
    'status': 'yes'
  },
  {
    'name': 'L\'Aquila',
    'status': 'yes'
  },
  {
    'name': 'La Spezia',
    'status': 'yes'
  },
  {
    'name': 'Latina',
    'status': 'yes'
  },
  {
    'name': 'Lecce',
    'status': 'yes'
  },
  {
    'name': 'Lecco',
    'status': 'yes'
  },
  {
    'name': 'Livorno',
    'status': 'yes'
  },
  {
    'name': 'Lodi',
    'status': 'yes'
  },
  {
    'name': 'Lucca',
    'status': 'yes'
  },
  {
    'name': 'Macerata',
    'status': 'yes'
  },
  {
    'name': 'Mantova',
    'status': 'yes'
  },
  {
    'name': 'Massa-Carrara',
    'status': 'yes'
  },
  {
    'name': 'Matera',
    'status': 'yes'
  },
  {
    'name': 'Messina',
    'status': 'no'
  },
  {
    'name': 'Milano',
    'status': 'yes'
  },
  {
    'name': 'Modena',
    'status': 'yes'
  },
  {
    'name': 'Monza e Brianza',
    'status': 'yes'
  },
  {
    'name': 'Napoli',
    'status': 'yes'
  },
  {
    'name': 'Novara',
    'status': 'yes'
  },
  {
    'name': 'Nuoro',
    'status': 'no'
  },
  {
    'name': 'Oristano',
    'status': 'no'
  },
  {
    'name': 'Padova',
    'status': 'yes'
  },
  {
    'name': 'Palermo',
    'status': 'no'
  },
  {
    'name': 'Parma',
    'status': 'yes'
  },
  {
    'name': 'Pavia',
    'status': 'yes'
  },
  {
    'name': 'Perugia',
    'status': 'yes'
  },
  {
    'name': 'Pesaro e Urbino',
    'status': 'yes'
  },
  {
    'name': 'Pescara',
    'status': 'yes'
  },
  {
    'name': 'Piacenza',
    'status': 'yes'
  },
  {
    'name': 'Pisa',
    'status': 'yes'
  },
  {
    'name': 'Pistoia',
    'status': 'yes'
  },
  {
    'name': 'Pordenone',
    'status': 'yes'
  },
  {
    'name': 'Potenza',
    'status': 'yes'
  },
  {
    'name': 'Prato',
    'status': 'yes'
  },
  {
    'name': 'Provincia',
    'status': 'Price'
  },
  {
    'name': 'Ragusa',
    'status': 'no'
  },
  {
    'name': 'Ravenna',
    'status': 'yes'
  },
  {
    'name': 'Reggio di Calabria',
    'status': 'no'
  },
  {
    'name': 'Reggio nell\'Emilia',
    'status': 'yes'
  },
  {
    'name': 'Rieti',
    'status': 'yes'
  },
  {
    'name': 'Rimini',
    'status': 'yes'
  },
  {
    'name': 'Roma',
    'status': 'yes'
  },
  {
    'name': 'Rovigo',
    'status': 'yes'
  },
  {
    'name': 'Salerno',
    'status': 'yes'
  },
  {
    'name': 'San Marino',
    'status': 'yes'
  },
  {
    'name': 'Sassari',
    'status': 'no'
  },
  {
    'name': 'Savona',
    'status': 'yes'
  },
  {
    'name': 'Siena',
    'status': 'yes'
  },
  {
    'name': 'Siracusa',
    'status': 'no'
  },
  {
    'name': 'Sondrio',
    'status': 'yes'
  },
  {
    'name': 'Sud Sardegna',
    'status': 'no'
  },
  {
    'name': 'Taranto',
    'status': 'yes'
  },
  {
    'name': 'Teramo',
    'status': 'yes'
  },
  {
    'name': 'Terni',
    'status': 'yes'
  },
  {
    'name': 'Torino',
    'status': 'yes'
  },
  {
    'name': 'Trapani',
    'status': 'no'
  },
  {
    'name': 'Trento',
    'status': 'yes'
  },
  {
    'name': 'Treviso',
    'status': 'yes'
  },
  {
    'name': 'Trieste',
    'status': 'yes'
  },
  {
    'name': 'Udine',
    'status': 'yes'
  },
  {
    'name': 'Varese',
    'status': 'yes'
  },
  {
    'name': 'Venezia',
    'status': 'yes'
  },
  {
    'name': 'Verbano-Cusio-Ossola',
    'status': 'yes'
  },
  {
    'name': 'Vercelli',
    'status': 'yes'
  },
  {
    'name': 'Verona',
    'status': 'yes'
  },
  {
    'name': 'Vibo Valentia',
    'status': 'no'
  },
  {
    'name': 'Vicenza',
    'status': 'yes'
  },
  {
    'name': 'Viterbo',
    'status': 'yes'
  }
]



// WEBPACK FOOTER //
// ./src/utils/helpers.js